import { useState, useEffect } from 'react'

export const useScreenWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0)
  const isWindow = typeof window !== 'undefined'

  const getWidth = () => (isWindow ? window.innerWidth : windowWidth)

  const resize = () => setWindowWidth(getWidth())

  useEffect(() => {
    if (isWindow) {
      setWindowWidth(getWidth())

      window.addEventListener('resize', resize)

      return () => window.removeEventListener('resize', resize)
    }
    //eslint-disable-next-line
  }, [isWindow])
  const isMobile = windowWidth < 700
  const isIpad = windowWidth >= 700 && windowWidth <= 1200
  const isDesktop = !isMobile && !isIpad
  return {
    windowWidth,
    isMobile,
    isIpad,
    isDesktop,
  }
}
